import React, {useEffect, useState} from "react"
import {apiGet} from "../../../Api/index";
import {Row, Col, Div, Text} from "atomize";
import Faq from "../../Molecules/Faq/index";
import theme from "../../../Theme/Theme";
import styled from "styled-components";
import Skeleton from "react-loading-skeleton";

const Wrapper = styled(Row)`
  border: 1px solid ${theme.colors.primary};
  padding: 3rem 2rem;
  margin-top: 6rem;
  justify-content: space-between;
  position: relative;
  background: white;
  
  &:before {
    border: 1px solid ${theme.colors.primary};
    display: block;
    height: 100%;
    width: 100%;
    content: "";
    left: 5px;
    position: absolute;
    top: 5px;
    z-index: -1;
    background: white;
  }
`;

const Intro = styled(Col)`
  p {
    color: ${theme.colors.dark};
    font-size: 20px;
    font-weight: 500;
    line-height: 32px;
  }
  
  @media only screen and (max-width: 766px) {
    margin-bottom: 2rem;
  }
`;

const Body = styled(Col)`

`;

function FeaturedFaq(props) {
  const [data, setData] = useState(null);

  useEffect(() => {
    async function fetchData() {
      const result = await apiGet(`/paragraph/featured_faq/${props.id}`);
      setData(result.data);
    }
    fetchData();
  }, []);

  return (
    <Wrapper>
      <>
        { data &&
          <Intro
            size={{ xs: '12', sm: '12', md: '6', lg: '5' }}
            dangerouslySetInnerHTML={ { __html: data.data.attributes.field_description.value} }
          />
        }
        {
          !data &&
            <Intro>
              <Skeleton
              count={6}
              />
            </Intro>
        }
        <Body
          size={{ xs: '12', sm: '12', md: '6', lg: '5' }}
        >
          { data &&
            data.data.attributes.field_faq.map( faq => {
              return (
                <Faq
                  key={faq.question}
                  question={faq.question}
                  answer={faq.answer}
                />
              )
            })
          }
          {
            !data &&
            <Skeleton
              count={6}
            />
          }
        </Body>
      </>
    </Wrapper>
  )
}



export default FeaturedFaq
